var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLandingPageBottomLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 166,
    viewBox: "0 0 132 166",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-183.339 0.886941C-172.678 2.02868 -161.905 3.47779 -151.048 5.25314C19.2731 33.1061 145.253 129.642 130.334 220.873C130.069 222.492 129.751 224.094 129.402 225.688L80.6054 217.708C80.9702 216.118 81.3043 214.519 81.5693 212.898C94.1293 136.094 -11.9297 54.8221 -155.32 31.3733C-166.206 29.5931 -176.99 28.2034 -187.639 27.1778L-183.339 0.886941Z",
    fill: "#FED57A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingPageBottomLeft);
export default __webpack_public_path__ + "static/media/landingPageBottomLeft.18222c79cbb2f385f07d64fceffc6f86.svg";
export { ForwardRef as ReactComponent };